<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer055">
<p class="content-chapter" id="calibre_toc_4"><a href="#/OEBPS/ebook_split_006#_idTextAnchor000">Foreword<span id="_idTextAnchor042"></span> </a></p>
<p class="body-text1">When the idea of <em class="italic">Postcards to the Universe </em>was born, I knew it was going to turn into a global movement. Melisa has discovered a new twist to manifesting: to be the creator of your reality and to direct your destiny, your vision and intention must seamlessly come<span> </span>together.</p>
<p class="body-text1">Very early on in this project, I would ask Melisa to come to my live classes and share her postcards with my students. I was teaching them how to use the zero-point field (the energy that surrounds us), by setting clear intentions, raising their emotional frequency, and running a movie of it all in their<span> </span>minds.</p>
<p class="body-text1">Adding in the postcard component was a way for them to enhance their creative visualization with her beautiful photography and send their cards out as an action for the intention to<span> </span>manifest.</p>
<p class="body-text1"><span class="dropcaps">Melisa has done an extraordinary job of combining art and manifestation, making it tangible and fun for us all to live our</span><span><span class="dropcaps"> </span></span><span class="dropcaps">dreams.</span></p>
<p class="postcard_author" id="calibre_pb_15">Jennifer Grace<br class="calibre3"/>Hay House Author.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_008.vue?6d491c5e